import { PaymentMethodEnum } from '@/types/common';
import { Box } from '../Common/Box';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const BancontactPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.BANCONTACT}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.BANCONTACT)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.BANCONTACT)} alt="bancontact" />
    </Box>
  );
};
